import React from "react";
import style from "./bar.module.css";
import { Task } from "../../../types/public-types";
import { truncateText } from "../../../helpers/tuncated-text";
import { useLocation } from "react-router-dom";

type BarDisplayProps = {
  task:Task
  x: number;
  y: number;
  width: number;
  height: number;
  isSelected: boolean;
  /* progress start point */
  progressX: number;
  progressWidth: number;
  barCornerRadius: number;
  styles: {
    backgroundColor: string;
    backgroundSelectedColor: string;
    progressColor: string;
    progressSelectedColor: string;
  };
  onMouseDown: (event: React.MouseEvent<SVGPolygonElement, MouseEvent>) => void;
};
export const BarDisplay: React.FC<BarDisplayProps> = ({
  task,
  x,
  y,
  width,
  height,
  isSelected,
  progressX,
  progressWidth,
  barCornerRadius,
  styles,
  onMouseDown,
}) => {
  const location = useLocation();
  const isProjectsPage = location.pathname.includes("projects");
  const isRealTask = !task.showProgress;
  const shouldShowBottom = isProjectsPage && isRealTask;

  const getProcessColor = () => {
    return isSelected ? styles.progressSelectedColor : styles.progressColor;
  };

  const getBarColor = () => {
    return isSelected ? styles.backgroundSelectedColor : styles.backgroundColor;
  };
  
  if (typeof task.showProgress  !== "boolean") {
    task.showProgress = true
  }
  return (
    <g onMouseDown={onMouseDown} z={2} data-type="Task" data-taskid={task.id}>
      <rect
        data-type="Task"
        data-taskid={task.id}
        id={task.id}
        x={x}
        width={width}
        y={y}
        height={height}
        ry={barCornerRadius}
        rx={barCornerRadius}
        fill={getBarColor() +"d4"}
        className={style.barBackground}
      />
      <rect
        data-type="Task"
        data-taskid={task.id}
        id={task.id}
        x={progressX}
        width={progressWidth}
        y={y}
        height={height}
        ry={barCornerRadius}
        rx={barCornerRadius}
        fill={getProcessColor()}
      />
      <text
        x={shouldShowBottom ? x : x + 5}
        y={shouldShowBottom ? y + height + 15 : y + (height / 2) + 5}
        z={1}
        fontSize={shouldShowBottom ? 12 : (height - 3) > 12 ? 12 : height - 3}
        fill={shouldShowBottom ? "#1e293b" : "#fff"}
        className="select-none pointer-events-none"
        style={shouldShowBottom ? {
          paintOrder: 'stroke',
          stroke: '#fff',
          strokeWidth: '3px',
          strokeLinejoin: 'round',
        } : {}}
      >
        {shouldShowBottom ? task.name : truncateText(task.name, width, Math.round(width) == 16)}
      </text>
      {Math.round(width) > 30 && task.showProgress &&  (
        <text x={Number(task.progress) == 100 ? x + width - 35: x + width - 25} y={y + (height/2)+5} fontSize={12} fill="#fff" className="pointer-events-none select-none">
          {Number(task.progress).toFixed()}% {/* Truncated text */}
        </text>
      )}
      
    </g>
  );
};
